var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 113,
    viewBox: "0 0 152 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6016_754)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3999 92.0345C54.5009 92.0345 63.4999 83.0354 63.4999 71.9345C63.4999 60.8335 54.5009 51.8345 43.3999 51.8345C32.299 51.8345 23.2999 60.8335 23.2999 71.9345C23.2999 83.0354 32.299 92.0345 43.3999 92.0345Z",
    fill: "#FF009D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7999 61.8345C113.331 61.8345 124.3 50.6416 124.3 36.8345C124.3 23.0274 113.331 11.8345 99.7999 11.8345C86.2689 11.8345 75.2999 23.0274 75.2999 36.8345C75.2999 50.6416 86.2689 61.8345 99.7999 61.8345Z",
    fill: "#00A5D5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7999 112.834C87.54 112.834 100.3 100.075 100.3 84.3345C100.3 68.5944 87.54 55.8345 71.7999 55.8345C56.0598 55.8345 43.2999 68.5944 43.2999 84.3345C43.2999 100.075 56.0598 112.834 71.7999 112.834Z",
    fill: "#FFDF00"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6299 106.504C94.1374 106.504 108.33 92.3119 108.33 74.8045C108.33 57.2971 94.1374 43.1045 76.6299 43.1045C59.1225 43.1045 44.9299 57.2971 44.9299 74.8045C44.9299 92.3119 59.1225 106.504 76.6299 106.504Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.689941 74.8044C0.689941 74.8044 70.7099 -11.0356 150.93 74.8044",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.689941 74.8042C0.689941 74.8042 70.7099 160.644 150.93 74.8042",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3099 0.834473L75.8099 31.3645",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.41 43.9047L1.95996 18.8247",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.87 34.7547L34.36 4.80469",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.1 43.9047L150.56 18.8247",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.65 34.7547L118.15 4.80469",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6016_754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150.99,
    height: 112.121,
    fill: "white",
    transform: "translate(0.689941 0.834473)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicLogo1);
export default __webpack_public_path__ + "static/media/graphic-logo-1.a64d335ec5fe3a37053cfbc756907d63.svg";
export { ForwardRef as ReactComponent };